export const style = {
  h2: {
    fontSize: `31px`,
    fontWeight: 300,
    lineHeight: `42px`,
    margin: `0 0 32px 0`,
    color: `black`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Terms/style/headers.js